import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AccountDialog({ open, onOpenChange }) {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const save = async () => {
    try {
      await api.post("/auth/change-password", f);
      toast.success("Password updated");
      setF({ current_password: "", new_password: "" });
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="account-dialog">
        <DialogHeader><DialogTitle>My account</DialogTitle></DialogHeader>
        <div className="text-sm text-slate-600">{user.name} · {user.email} · {user.role?.name}</div>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label>Current password</Label><Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password-input" /></div>
          <div className="space-y-1.5"><Label>New password (min. 8 characters)</Label><Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password-input" /></div>
        </div>
        <DialogFooter><Button onClick={save} className="bg-orange-500 hover:bg-orange-600" data-testid="change-password-submit">Update password</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
